import React from "react";
import "./index.css";

const RecomendationPasswordComponent = () => {
  return (
    <div className="recomendation-wrapper">
      We recommend a strong password that is:
      <div className="pointers">
        <div>-</div>
        <div>generated by your browser or a password manager.</div>
     
        </div>
        <div className="pointers">
          <div>-</div>
          <div>not used by other Internet accounts.</div>
      </div>
    </div>
  );
};

export const RecomendationPassword = RecomendationPasswordComponent;
